import React, { useState } from 'react';
import FooterImage from '../assets/imageFooter.png';
import emailjs from 'emailjs-com';

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [isSent, setIsSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage(null);

        emailjs.send(
            'aiavatar',
            'template_8f9ze7a',
            formData,
            'bqX9OFBB8HdLWSXUh'
        )
            .then(() => {
                setIsSent(true);
                setFormData({ name: '', email: '', message: '' });
                setMessage({ type: 'success', text: '✅ Your email has been sent successfully!' });
            })
            .catch((error) => {
                console.error('Email send error:', error);
                setMessage({ type: 'error', text: '❌ Failed to send email. Please try again.' });
            })
            .finally(() => {
                setLoading(false);

                // Hide the message after 5 seconds
                setTimeout(() => setMessage(null), 5000);
            });
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100"
            style={{
                background: `linear-gradient(0deg,rgba(0,0,0,.6),rgba(0,0,0,.6)),url(${FooterImage})`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
            }}
        >
            <div className="p-4 text-white w-100" style={{ maxWidth: '500px' }}>
                <h2 className="text-center mb-4 pb-3" style={{ fontSize: '4rem' }}>Contact Us</h2>


                {message && (
                    <div className={`alert ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`} role="alert">
                        {message.text}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label text-light">Name</label>
                        <input placeholder='name' type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-light">Email</label>
                        <input placeholder='email' type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                    </div>

                    <div className="mb-3">
                        <label className="form-label text-light">Message</label>
                        <textarea placeholder='message' name="message" className="form-control" rows="4" value={formData.message} onChange={handleChange} required />
                    </div>

                    <div className="text-center">
                        <button type="submit" className="btn btn-primary w-100 p-3 bold" disabled={loading}>
                            {loading ? (
                                <div className="d-flex justify-content-center align-items-center">
                                    <span className="spinner-border spinner-border-sm me-2"></span> Sending...
                                </div>
                            ) : (
                                "Submit"
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default ContactUs;
